function imageCarouselHero() {
    $(function() {
        $(".image-carousel-hero").each(function() {
            const $carousel = $(this);

            $(".play-state-toggle", $carousel).on("click", function(e) {
                e.preventDefault();

                const toggle = $(this);
                const target = toggle.data("target");
                const state = $(target).data("bs.carousel").paused;

                $(target).carousel(state ? "cycle" : "pause");

                $(".carousel-inner", $(target)).attr("aria-live", state ? "polite" : "off");

                $(this)
                    .removeClass("play pause")
                    .addClass(() => (state ? "play" : "pause"));
            });

            // Keyboard accessibility for indicators
            $(".carousel-indicators li", $carousel).on("keydown", function(e) {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    const slideTo = $(this).data("slide-to");
                    const target = $(this).data("target");

                    $(target).carousel(slideTo);
                }
            });
        });
    });
}

export default imageCarouselHero;
